import React from 'react';
import { Star, StarHalf, User, ArrowUpRight } from 'lucide-react';
import ReviewReplySection from '../../../components/ReviewReplySection';

const ReviewCard = ({ review }) => {
  const renderStars = () => {
    const stars = [];
    const fullStars = Math.floor(review.rating);
    const hasHalfStar = review.rating % 1 !== 0;

    for (let i = 1; i <= 5; i++) {
      if (i <= fullStars) {
        stars.push(<Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />);
      } else if (i === fullStars + 1 && hasHalfStar) {
        stars.push(<StarHalf key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />);
      } else {
        stars.push(<Star key={i} className="w-4 h-4 text-gray-200" />);
      }
    }
    return stars;
  };

  return (
    <div className="bg-white/60 backdrop-blur-md rounded-[2rem] p-6 border border-white/50 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500 group flex flex-col justify-between">
      <div>
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center border border-primary/10 group-hover:bg-primary transition-all duration-500">
            <User className="w-6 h-6 text-primary group-hover:text-white" />
          </div>
          <div>
            <h3 className="text-sm font-bold text-gray-900 group-hover:text-primary transition-colors">
              {review.booking_id?.name || 'Guest'}
            </h3>
            <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider">Verified Purchase</p>
          </div>
          <div className="ml-auto">
            <div className="bg-emerald-50 text-emerald-600 text-[10px] font-bold px-2 py-1 rounded-full border border-emerald-100 flex items-center gap-1">
              <Star size={10} className="fill-emerald-600" /> {review.rating.toFixed(1)}
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <div className="flex gap-0.5">{renderStars()}</div>
          <h4 className="text-base font-bold text-gray-800 line-clamp-1">{review.title || "Excellent Experience"}</h4>
          <p className="text-gray-500 text-sm leading-relaxed line-clamp-3 font-medium italic">"{review.description}"</p>
        </div>
      </div>

      <div>
        <div className="mt-6 pt-4 border-t border-gray-50 flex items-center justify-between">
          <span className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">
            {new Date(review.createdAt).toLocaleDateString()}
          </span>
          <button className="text-primary hover:text-primary/80 transition-colors uppercase text-[10px] font-bold tracking-tighter flex items-center gap-1">
            Read Full <ArrowUpRight size={12} />
          </button>
        </div>

        <ReviewReplySection review={review} tokenStorageKey="token_partner_restaurant" />
      </div>
    </div>
  );
};

export default ReviewCard;
